export default {
      id: "sli-logout-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b3fb107f.svg#sli-logout",
      toString: function () {
        return this.url;
      }
    }